export const LoaderCard = () => {
  return (
    <div className="bg-popupLight dark:bg-popupDark rounded-xl shadow-md p-4 animate-pulse">
      <div className="w-full h-40 bg-gray-300 dark:bg-gray-700 rounded-lg mb-4"></div>
      <div className="h-4 bg-gray-300 dark:bg-gray-700 rounded mb-2"></div>
      <div className="h-3 bg-gray-300 dark:bg-gray-700 rounded mb-3"></div>
      <div className="flex items-center justify-between">
        <div className="w-12 h-4 bg-gray-300 dark:bg-gray-700 rounded"></div>
        <div className="w-16 h-6 bg-gray-300 dark:bg-gray-700 rounded"></div>
      </div>
    </div>
  );
};
